var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTopSeller = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m15.235 7.83 4.59-2.604a1.87 1.87 0 0 1 1.68.51c.43.436.595 1.052.435 1.63l-2.463 8.944c-.21.762-.933 1.293-1.76 1.293H6.283c-.826 0-1.549-.531-1.758-1.293L2.06 7.366a1.68 1.68 0 0 1 .435-1.63 1.87 1.87 0 0 1 1.68-.51l4.582 2.603 1.956-5.32A1.86 1.86 0 0 1 12 2c.483 0 .946.183 1.287.509zM6.273 19.143c-.787 0-1.425.64-1.425 1.428 0 .79.638 1.429 1.425 1.429h11.11c.787 0 1.425-.64 1.425-1.429s-.638-1.428-1.424-1.428z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTopSeller);
export default ForwardRef;